import React, {Dispatch, SetStateAction} from "react";
import {
    AllStates,
    asJsonformsErrorTranslate,
    asJsonformsTranslate,
    JSON_FORMS_CONFIG,
    StepForm,
    TranslateFunction
} from '../Forms';

import schema from './comment.schema.json';

import {JSONSchema7} from "json-schema";
import {JsonForms} from "@jsonforms/react";
import uischema from "./comment.uischema.json";
import {materialCells, materialRenderers} from "@jsonforms/material-renderers";
import {Comment} from './Comment';
import {I18nMessage} from "../Representation";

export const EMPTY_COMMENT: Comment = {};

const FORM_NS = "comment_form.";

export class CommentForm extends StepForm {

    constructor() {
        super(schema as JSONSchema7);
    }

    getFormNs(): string | undefined {
        return FORM_NS;
    }

    getTitleKey() {
        return "comment_title";
    };

    getPage([formData, setFormData]: [any, Dispatch<SetStateAction<any>>],  _allStates: AllStates, t: TranslateFunction, lang: string) {
        return (<React.Fragment>
            <JsonForms
                schema={schema}
                uischema={uischema}
                data={formData}
                renderers={materialRenderers}
                cells={materialCells}
                config={JSON_FORMS_CONFIG}
                i18n={{
                    translate: asJsonformsTranslate(t, FORM_NS),
                    locale: lang,
                    translateError: asJsonformsErrorTranslate(t)
                }}
                onChange={({data}) => setFormData(data)}
            />
        </React.Fragment>);
    }

    getContextMessageKeys = (data: any, _allStates: AllStates): [I18nMessage[], I18nMessage[]] => {
        const comment = ((data as unknown) as Comment);
        if (comment === undefined) {
            return [["missing_data"], []];
        }

        return [[], []];
    }

    getExplanationMarkdownKey(): string {
        return "comment.explanation.markdown";
    }

    getHelpUrl(): string {
        return "faq.html#comment";
    }

}